import { useStoreWithOptinItemsList } from 'modules/stores/store/content/optin/optin-rules/hooks/use-store-with-optin-items-list'
import { StoreId } from 'modules/stores/types/stores-interface'
import { StoreTriggerDataInterface } from '../utils/fill-trigger-with-store-data'
import { useStoreOptinItemsList } from './use-store-optin-items-list'

export const useStoreRuleData = (storeId: StoreId, optinId: number) => {
  const { data: stores } = useStoreWithOptinItemsList(true)

  const store = stores?.find(store => store.id === storeId)

  const { data: optinItems } = useStoreOptinItemsList(store?.id, true)

  const optinItem = optinItems?.find(item => item.id === optinId)

  const storeTriggerData: StoreTriggerDataInterface | undefined =
    store && optinItem
      ? {
          storeId: store.id,
          storeName: store.name,
          itemId: optinItem.id,
          itemName: optinItem.title,
        }
      : undefined

  return { storeTriggerData }
}
